module.exports = __webpack_public_path__ + "static/media/otherOptionsQuestion.47124ed7.mp3";